import React, { PureComponent } from 'react';
import { Button,Popover,Spin,message} from 'antd';
import Lang from "@components/Lang/Lang";
import ReactContext from "@store/reactContext";
import FollowAction from "../../Follow/Follow.action";
import "./AllocationFollowUserBtn.less";
/**
 * 跟进按钮
 *
 * */
export default class AllocationFollowUserBtn extends PureComponent {
    static contextType = ReactContext;
    static defaultProps = {
       row:{}
    };
    constructor(props) {
        super(props);
        this.state = {
            open: false,
        }
    }
     showPop = (flag=false,getFlag=false) => {
        if(getFlag){
            this.getList()
        }
         this.setState({
             open:flag
         })
    };
    close=()=>{
        this.showPop(false)
    }
    loading(flag) {
        this.setState({
            loading: flag,
        });
    }
    /**
     * 业务员用户列表
     * http://rap.essa.top:88/workspace/myWorkspace.do?projectId=210#8304
     */
    getList() {
        this.loading(true);
        FollowAction.postAction("/service/mg/follower/salesman-list",{}).then(res=>this.handleRes(res.data)).catch(err=>this.handleRes(err));
    }
    handleRes(res={}) {
        this.loading(false);
        const {success, valid, models=[]} = res;
        if (success && valid) {
            this.setState({
                list:models
            })
        }
    }
    clickItem(id){
        this.setState({
            currentId:id
        })
    }
    /**
     * 点击确认时 获取表单数据
     ***/
    handleOK(){
        this.loading(true);
        const { buyerId } = this.props;
        const { currentId } = this.state;
        if(buyerId){
            FollowAction.postAction("/service/mg/follower/allocation-follow-user",{
                buyerId: buyerId,
                userId: currentId,
            }).then(res=>this.handleResOK(res.data)).catch(err=>this.handleResOK(err));
        }
    }
    handleResOK(res={}) {
        this.loading(false);
        const {success, valid, } = res;
        if (success && valid) {
            this.showPop(false);
            message.success(Lang({id:"BangDingChengGong2",default:"绑定成功"}));
            if(this.props.reRefreshSearch){
                this.props.reRefreshSearch();
            }
        }
    }
    /**
     * 获取
     * */
    stopPropagation(e) {
        e.nativeEvent.stopImmediatePropagation();
    }
    componentDidMount() {
        document.addEventListener('click', this.close);
    }
    componentWillUnmount() {
        document.removeEventListener('click', this.close);
    }
    render() {
        const {foreignUserName,foreignUserId,buyerId} = this.props;
        const { context={} } = this;
        const {list=[],loading=false,currentId="",open=false} = this.state;
        const setId = currentId||foreignUserId;
        const _extraState = context._extraState||{};
        const positionCode = _extraState.positionCode||"";
        // 0 销售经理（全），1 业务员 (注册客户—待办+新客图例)，2 客服 (已成交客户—待办+已成交客户图例)，3 会计， 4 清关，5 仓管，6 商品经理，7 管理员（全）
        const hadPermi = positionCode === "0" || positionCode=== "7"; //管理员  和  销售经理才有分配权限
        return (hadPermi?<Popover placement="bottom"
                       arrow={false}
                       overlayStyle={{width:"360px"}}
                       color={"#fff"}
                       // trigger="click"
                       open={open}
                       destroyTooltipOnHide={true}
                       content={<div className={"popAllocationFollowUser"} onClick={(e)=>this.stopPropagation(e)} >
                           <Spin spinning={loading}>
                               <div className={"popAllocationWrap"}>
                                    {list.map((item,inx)=><div className={`item${item.id==setId?" on":""}`}
                                                               key={item.id+"_"+inx} onClick={()=>this.clickItem(item.id)}>
                                        {item.name}
                                    </div>)}
                               </div>
                           <div className={"text-center"}>
                               <Button type="primary" onClick={()=>this.handleOK()} loading={loading}>
                                   {Lang({id:'QueDing',default:'确定'})}
                               </Button>
                           </div>
                           </Spin>
                       </div>}>
                        <div key={"allB_"+buyerId} className={`mt_4 allocationFollowUserBtnBlue cursor-p ${foreignUserName?"":" color-blue3"}`} onClick={(e)=>{
                            this.stopPropagation(e);
                            this.showPop(true,true)
                        }}>
                            <i className={"ri-user-line mr_4 font_18 black45"} />{foreignUserName||Lang({id:"WeiFenPei",default:"未分配"})}
                        </div>
                </Popover>:<div key={"allB_"+buyerId} className={`mt_4 allocationFollowUserBtnBlue${foreignUserName?"":" color-blue3"}`}>
                <i className={"ri-user-line mr_4 font_18 black45"} />{foreignUserName||Lang({id:"WeiFenPei",default:"未分配"})}
            </div>);
    }


};
